import Icon from '@/components/ui/AppIcon';

const approaches = [
  {
    id: 'approach_1',
    icon: 'LightBulbIcon' as const,
    title: 'Creative Vision',
    description:
      'Cinematic, natural light photography with editorial influence. Every shot is carefully composed to tell a compelling visual story.',
  },
  {
    id: 'approach_2',
    icon: 'UserGroupIcon' as const,
    title: 'Collaborative Process',
    description:
      'I work closely with clients to understand their vision and bring it to life. Your input shapes the creative direction.',
  },
  {
    id: 'approach_3',
    icon: 'HeartIcon' as const,
    title: 'Authentic Emotion',
    description:
      'Capturing genuine moments and real emotions. I create a relaxed atmosphere where authenticity shines through.',
  },
  {
    id: 'approach_4',
    icon: 'SparklesIcon' as const,
    title: 'Refined Post-Processing',
    description:
      'Expert editing that enhances without overwhelming. Natural color grading and subtle retouching maintain authenticity.',
  },
]

export default function ApproachSection() {
  return (
    <section className="py-16">
      <div className="reveal">
        <h3 className="text-3xl font-bold text-white mb-8">
          My Photography Style
        </h3>
        <div className="grid md:grid-cols-2 gap-6">
          {approaches.map((approach) => (
            <div
              key={approach.id}
              className="glass-panel rounded-2xl p-8 space-y-4 hover:bg-card transition-all duration-500"
            >
              <div className="w-12 h-12 rounded-lg bg-white/10 flex items-center justify-center">
                <Icon name={approach.icon} size={24} className="text-white" />
              </div>
              <h4 className="text-xl font-bold text-white">{approach.title}</h4>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {approach.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}